// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__36dhS","rootSuccess":"CompleteLink_rootSuccess__1Wuv-","rootFailure":"CompleteLink_rootFailure__2aR7n","isDisabled":"CompleteLink_isDisabled__1dkBe"};